import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/common/img-pagetop.svg'


const _withScopeId = n => (_pushScopeId("data-v-b7b3bd84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "l-wrapper" }
const _hoisted_2 = { class: "l-wrapper_main" }
const _hoisted_3 = { class: "p-login" }
const _hoisted_4 = { class: "p-login-inner" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-login-heading-1" }, "パスワードを忘れた・ログインできない方へ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-login-text-block --no-mt" }, [
  /*#__PURE__*/_createElementVNode("p", null, "弊社サービスお申込み時に登録された「メールアドレス」「電話番号」をご入力ください。"),
  /*#__PURE__*/_createElementVNode("p", null, "ご入力いただいたメールアドレスあてに、パスワードの再設定フォームのURLを送付いたします。")
], -1))
const _hoisted_7 = ["onSubmit"]
const _hoisted_8 = { class: "p-login-form__field" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-login-form__label",
  for: "login-mail"
}, "メールアドレス", -1))
const _hoisted_10 = { class: "p-login-form__field" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-login-form__label",
  for: "login-phone"
}, "電話番号 ※数字のみ(ハイフン抜き)で入力してください", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-login-text-block" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "--is-centered" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://mynavi-agent.jp/privacy/",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "個人情報の取り扱いについて")
  ])
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-login-text-block" }, [
  /*#__PURE__*/_createElementVNode("p", null, "個人情報の取り扱いに同意いただいたうえで、送信してください。")
], -1))
const _hoisted_14 = { class: "p-login-form__field --is-centered" }
const _hoisted_15 = { class: "p-login-form__checkbox" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-login-form__label --pc-txt-14 --is-inline",
  for: "login-agree"
}, "同意する", -1))
const _hoisted_18 = { class: "p-login-form__field" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-login-text-block" }, [
  /*#__PURE__*/_createElementVNode("p", null, "※メールアドレスと電話番号が一致しない場合は確認メールが送信されません。"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("※メールアドレスが不明な場合は、お手数ですが"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://survey.mynavi.jp/cre/?enq=jyLRMFjBeyo%3d",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "お問い合わせフォーム"),
    /*#__PURE__*/_createTextVNode("よりお問い合わせください。")
  ])
], -1))
const _hoisted_21 = { class: "l-wrapper_nav" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<div class=\"p-recommend-form__modal-card -is-complete\" data-v-b7b3bd84><a class=\"p-recommend-form__modal-help-close js-modal-close-trigger\" href=\"/login/\" data-v-b7b3bd84>閉じる</a><p class=\"p-recommend-form__text-7\" data-v-b7b3bd84>パスワード確認依頼完了</p><a class=\"p-recommend-form__modal-help-close-2\" href=\"/login/\" data-v-b7b3bd84>ログイン画面へ</a></div><div class=\"p-recommend-form__modal-close-area\" data-v-b7b3bd84></div>", 2)
const _hoisted_27 = [
  _hoisted_25
]

import Loading from '@/components/Loading.vue';
import { ref } from 'vue';
import { postPasswordReissue } from '@/api/accountEndpoint';
import { isValidEmail, isValidMaxLength, isValidHalfNumber, isValidRequired } from '@/plugins/validation';
import { errorMessage } from '@/constants/validationErrors';
import { domHelperUtils } from '@/utils/domHelper';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginForgetView',
  setup(__props) {

const isLoading = ref(false);
const isModalActive = ref(false);
const isAgreed = ref(false);

let isErrorEmailInput = ref(false);
let emailErrorMessage = ref('');
let isErrorTelInput = ref(false);
let telErrorMessage = ref('');
let isErrorForget = ref(false);
let forgetErrorMessage = ref('');

function scrollToTop() {
  domHelperUtils.scrollToTop();
}

const loginForgetAction = async () => {
  isErrorEmailInput.value = false;
  isErrorTelInput.value = false;
  isErrorForget.value = false;

  isLoading.value = true;

  // メールアドレスの入力値を取得
  const loginMailInput = document.getElementById('login-mail') as HTMLInputElement;
  const loginMailValue = loginMailInput ? loginMailInput.value : '';

  // 電話番号の入力値を取得
  const loginTelInput = document.getElementById('login-phone') as HTMLInputElement;
  const loginTelValue = loginTelInput ? loginTelInput.value : '';

  // 入力チェック(メールアドレス)
  // メールアドレスの文字数
  if (loginMailValue !== '') {
    if (!isValidMaxLength(loginMailValue, 255)) {
        isErrorEmailInput.value = true;
        emailErrorMessage.value = errorMessage('MAX_LENGTH', { label: 'メールアドレス',  max: '255' });
    }
    // メールアドレスの形式
    if (!isValidEmail(loginMailValue)) {
      isErrorEmailInput.value = true;
      emailErrorMessage.value = errorMessage('EMAIL');
    }
  }

  // 入力チェック(電話番号)
  if (loginTelValue !== '') {
    // 電話番号の文字数
    if (!isValidMaxLength(loginTelValue, 14)) {
      isErrorTelInput.value = true;
      telErrorMessage.value = errorMessage('MAX_LENGTH', { label: '電話番号',  max: '14' });
    }
    // 電話番号の形式(半角数値)
    if (!isValidHalfNumber(loginTelValue)) {
      isErrorTelInput.value = true;
      telErrorMessage.value = errorMessage('NUMERIC', { label: '電話番号' });
    }
  }

  // 必須チェック
  if (loginMailValue === '' || loginTelValue === '') {
    if (!isValidRequired(loginMailValue)) {
      isErrorEmailInput.value = true;
      emailErrorMessage.value = errorMessage('REQUIRED', { label: 'メールアドレス' });
    }
    if (!isValidRequired(loginTelValue)) {
      isErrorTelInput.value = true;
      telErrorMessage.value = errorMessage('REQUIRED', { label: '電話番号' });
    }
  }
  if (isErrorEmailInput.value || isErrorTelInput.value) {
    isLoading.value = false;
    return;
  }

  try {
    await postPasswordReissue({
      emailAddress: loginMailValue,
      telCellular: loginTelValue
    });
    // 新しく発行したユニークキー
    //alert("uniqueKey:" + res.uniqueKey)
    // ここでメール通知
  } catch (error) {
    console.error(error);
    let args = (error as { response: { data: { errorDetail: { globalError: { args: string[] }[] } } } }).response.data.errorDetail.globalError[0]
      .args || [];
    let code = (error as { response: { data: { errorDetail: { globalError: { args: string[] }[] } } } }).response.data.errorDetail.globalError[0]
      .code || [];
    if (code === 'EC001') {
      isErrorForget.value = true;
      forgetErrorMessage.value = args[0];
      isLoading.value = false;
      return;
    }
  } finally {
    isLoading.value = false;
  }
  isModalActive.value = true;
  isLoading.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("main", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("form", {
              class: "p-login-form",
              onSubmit: _withModifiers(loginForgetAction, ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("p", { class: "p-login-form__error" }, _toDisplayString(_unref(emailErrorMessage)), 513), [
                  [_vShow, _unref(isErrorEmailInput)]
                ]),
                _hoisted_9,
                _createElementVNode("input", {
                  class: _normalizeClass(["p-login-form__text", { '--is-error': _unref(isErrorEmailInput) }]),
                  id: "login-mail",
                  name: "login-mail",
                  placeholder: "メールアドレス（半角）"
                }, null, 2)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("p", { class: "p-login-form__error" }, _toDisplayString(_unref(telErrorMessage)), 513), [
                  [_vShow, _unref(isErrorTelInput)]
                ]),
                _hoisted_11,
                _createElementVNode("input", {
                  class: _normalizeClass(["p-login-form__text", { '--is-error': _unref(isErrorTelInput) }]),
                  id: "login-phone",
                  type: "number",
                  name: "login-phone",
                  placeholder: "電話番号"
                }, null, 2)
              ]),
              _withDirectives(_createElementVNode("p", { class: "p-login-form__error" }, _toDisplayString(_unref(forgetErrorMessage)), 513), [
                [_vShow, _unref(isErrorForget)]
              ]),
              _hoisted_12,
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, [
                  _withDirectives(_createElementVNode("input", {
                    id: "login-agree",
                    type: "checkbox",
                    name: "login-agree",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isAgreed).value = $event))
                  }, null, 512), [
                    [_vModelCheckbox, isAgreed.value]
                  ]),
                  _hoisted_16
                ]),
                _hoisted_17
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("button", {
                  class: "p-login-button",
                  type: "submit",
                  disabled: !isAgreed.value
                }, "送信する", 8, _hoisted_19)
              ])
            ], 40, _hoisted_7),
            _hoisted_20
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("a", {
          class: "g-pagetop",
          href: "#",
          "aria-label": "ページトップへ戻る",
          onClick: _withModifiers(scrollToTop, ["prevent"])
        }, _hoisted_24, 8, _hoisted_22)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["p-recommend-form__modal js-modal-container", { 'is-active': isModalActive.value }]),
      id: "send-complete"
    }, _hoisted_27, 2)
  ], 64))
}
}

})